import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute } from "@tanstack/react-router";
import { Sidebar } from "./Sidebar";

export const Route = createFileRoute("/supplier/$supplierId/settings")({
  pendingComponent: PagePending,
  beforeLoad: async () => {
    return {
      sidebar: <Sidebar />,
    };
  },
});
